"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonsWrapper = exports.SummaryAmountWrapper = exports.SummaryContent = exports.SummaryWrapper = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.SummaryWrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    width: '100%',
    boxShadow: '$upSoft',
    height: '170px',
    flexDirection: 'column',
});
exports.SummaryContent = (0, flora_react_1.styled)(flora_react_1.Flex, {
    alignItems: 'center',
    background: '$backgroundPrimary',
    bottom: '0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '$4 $7',
});
exports.SummaryAmountWrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '$4',
    ' p': {
        color: '$nonInteractivePredominant',
        lineHeight: '$taller',
        span: {
            color: '$nonInteractivePredominant',
        },
    },
});
exports.ButtonsWrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    width: '100%',
    gap: '$2',
    flexDirection: 'column',
    'button, a': {
        display: 'flex',
        width: '100%',
        textDecoration: 'none',
        '@desktop': {
            width: '100%',
        },
    },
});
